export default __webpack_public_path__ + "static/media/bars.cfc60e09.svg";